import { createRootRoute, Outlet } from '@tanstack/react-router';
import { TanStackRouterDevtools } from '@tanstack/router-devtools';
import { AuthProvider } from '@/providers/AuthProvider';
import { Toaster } from "@/components/ui/sonner"

function ErrorComponent({ error }: { error: Error }) {
  return (
    <div className="flex min-h-screen items-center justify-center bg-red-50 p-8">
      <div className="w-full max-w-md bg-white rounded-lg shadow-xl p-6">
        <h1 className="text-2xl font-bold text-red-600 mb-4">Something went wrong</h1>
        <p className="text-gray-700 mb-4">{error.message}</p>
        <button
          onClick={() => window.location.reload()}
          className="w-full bg-red-600 text-white rounded-lg py-2 px-4 hover:bg-red-700 transition-colors"
        >
          Reload Page
        </button>
      </div>
    </div>
  );
}

export const Route = createRootRoute({
  component: RootComponent,
  errorComponent: ErrorComponent,
});

function RootComponent() {
  return (
    <AuthProvider>
      <Outlet />
        <Toaster />
      {import.meta.env.DEV && <TanStackRouterDevtools />}
    </AuthProvider>
  );
}
